import React from 'react';
import LoginPage from '../components/Auth/LoginPage';


function LoginPageWrapper() {
  return <LoginPage />;
}

export default LoginPageWrapper; 